import React from 'react';
import pic1 from '../../../../Assets/InforPage/Infor_2.jpg';

const PhotoCollab = () => {
  return (
    <div className="w-full min-h-screen p-2 md:p-8 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-6xl mx-auto rounded-3xl overflow-hidden  bg-white">
        <div className="flex flex-col lg:flex-row">
          {/* Left side - Single Photo */}
          <div className="lg:w-2/5 p-8 md:p-12 relative">
            {/* Background decorative elements */}
            <div className="absolute top-1/2 left-1/2 w-80 h-80 md:w-96 md:h-96 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl opacity-10 bg-blue-400"></div>
            <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full blur-3xl opacity-5 bg-purple-500"></div>
            <div className="absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full blur-3xl opacity-5 bg-red-400"></div>
            
            <div className="relative flex items-center justify-center h-auto md:h-96">
              {/* Centered image box */}
              <div className="group max-w-96 h-60 md:h-96 relative overflow-hidden rounded-3xl transform hover:scale-102 transition-all duration-500 shadow-lg">
                <img 
                  src="https://ik.imagekit.io/kqumni8l2/PhotoCollab/PhotoCollab_4.jfif?updatedAt=1737458782705"
                  alt="CEO portrait"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
          </div>
          
          {/* Right side - Content */}
         <div className="lg:w-3/5 p-6 md:p-8 flex flex-col justify-center">
  <div className="flex flex-col md:flex-row items-start md:items-center ">
    <h2
      className="text-4xl md:text-4xl font-bold"
      style={{ 
        background: 'linear-gradient(135deg, #0012d8, #e60337, #FF0000)',
        WebkitBackgroundClip: 'text', 
        WebkitTextFillColor: 'transparent', 
        display: 'inline',
      }}
    >
      KCS Tech
    </h2>
    <span className="text-md ml-0 md:ml-4 mr-2  md:mt-0 text-slate-600 font-medium">As an esteemed</span>
    <img 
      src="https://ik.imagekit.io/kqumni8l2/inforAlliance%20PatnerLogo.png?updatedAt=1737438400542" 
      alt="InforAlliance partner" 
      className="h-8 md:h-10 mb-5 md:mt-0"
    />
  </div>
  
  <p className="text-md text-left mb-8 text-slate-600">
    Dive into the heart of KCS Technologies where our team of experts are dedicated to the delivering cutting-edge services that transform business. From ERP consulting to digital transformation, explore our services to achieve full potential in today's fast-paced landscape.
  </p>
</div>
        </div>
      </div>
    </div>
  );
};

export default PhotoCollab;